"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_odd_1 = require("../filters/is_odd");
exports.evenOddSplit = (evenMethod, oddMethod) => (value, index, array) => {
    return is_odd_1.default(index)
        ? oddMethod(value, index, array)
        : evenMethod(value, index, array);
};
//# sourceMappingURL=even_odd_split.js.map